import React, { useState } from "react"
import InfraCarousel from "../components/home/infraCarousel"
import BackgroundImage from "gatsby-background-image"
import { CSSTransition } from "react-transition-group"


const Crystals = ({ images, text, className }) => {
  const [active, setActive] = useState('laser-crystals');
  const [menuHeight, setMenuHeight] = useState(613)

  const response = {
    desktop: {
      breakpoint: { max: 1920, min: 1024 },
      items: 3,
      slidesToSlide: 2,
      partialVisibilityGutter: 25
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2,
      partialVisibilityGutter: 30
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 60
    }
  }

  const calcHeigth = (el) => {
    const height = el.offsetHeight
    setMenuHeight(height)
  }

  return <div className={className} style={{ height: menuHeight }} >
    <div className="tab">
      <div className="tab__links">
        {text.map(({ title, slug }) =>
          <div className="tab__link-wrapper" key={slug}>
            <a
              className={`tab__link${active === slug ? ' active' : ''}`}
              onClick={() => setActive(slug)}
            >
              {title}
            </a>
          </div>
        )}
      </div>
    </div>
    <div className="tab__content">
      {text.map(({ slug, data }) => 
          <CSSTransition
            key={slug}
            in={slug === active}
            //mountOnEnter
            unmountOnExit
            timeout={500}
            classNames="tab-content__item"
            onEntered={calcHeigth}
          >
            <InfraCarousel responsive={response}>
              {data.map(({ slug, title, description }) =>
                <div className="card" key={slug}>
                  <BackgroundImage
                    className="image"
                    fluid={images.find(({ name }) => name === slug).image.fluid}
                    alt={images.find(({ name }) => name === slug).image.originalName}
                  />
                  <div className="card__text">
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                </div>
              )}
            </InfraCarousel>
          </CSSTransition>
        )}
    </div>
  </div>
}

export default Crystals